import { render, staticRenderFns } from "./up.vue?vue&type=template&id=048773a3&"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/spee2/www/univers/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('048773a3')) {
      api.createRecord('048773a3', component.options)
    } else {
      api.reload('048773a3', component.options)
    }
    module.hot.accept("./up.vue?vue&type=template&id=048773a3&", function () {
      api.rerender('048773a3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/parametric/svg-media/up.vue"
export default component.exports